<template>
  <div class="newArea-appoint">
    <!-- 活动标题 -->
    <div v-wechat-title='"新春仙二「余情」特别服预约开启！"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-hjwq' v-show='preloadingShow'></div>
    </transition>
    <Header :isOnline="0" :config='headerConfig' :isShowInfo='true' @reInit="reInit" />

    <div class='home-page'>
      <div class="content1">
        <div class="title">
          <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
            <img v-show="titleShow" src="../../../../assets/images/active/hjwq/newArea-appoint/title.png" />
          </transition>
        </div>
        <div class="btn-rule" @click="handleShowDetail">
          <img src="../../../../assets/images/active/hjwq/newArea-appoint/btn_rule.png" alt="">
        </div>
        <div class="btn-appoint">
          <img v-if="userInfo.account && !downLoadShow" src="../../../../assets/images/active/hjwq/newArea-appoint/btn_appoint_success.png" alt="">
          <img v-if="downLoadShow" @click="handleDownload" src="../../../../assets/images/active/hjwq/newArea-appoint/btn_download.png" alt="">
          <img v-if="!userInfo.account && !downLoadShow" @click="handleAppoint" src="../../../../assets/images/active/hjwq/newArea-appoint/appoint.png" alt="">
        </div>
        <div class="appoint-num-box">
          <div class="num">{{ appointNumber }}</div>
        </div>
        <div ref="btnNext" :class="['btn-next', hideMoveDown ? 'hide' : '']"></div>
      </div>
      <div class="content2"></div>
      <div class="content3">
        <div class="achieve-2000" v-show="appointNumber >= 2000"></div>
        <div class="achieve-2500" v-show="appointNumber >= 3500"></div>
        <div class="achieve-5000" v-show="appointNumber >= 5000"></div>
      </div>
      <div class="content4">
        <div class="headers-box">
          <div v-for="(item, idx) of (team_info)" :key="idx" class="item">
            <div class="top">
              <img v-if="team[idx] && team[idx].avatar" class="avatar" :src="team[idx].avatar" alt="">
              <span v-else-if="team[idx] && !team[idx].avatar && team[idx].nickname" :class="['avatar', `avatar-${idx}`]"></span>
              <img v-else class="avatar" @click="handleInvite" src="../../../../assets/images/active/hjwq/newArea-appoint/btn_invite.png" alt="">
            </div>
            <div class="bottom">{{ team[idx] && team[idx].nickname ? `大侠-${team[idx].nickname}` : '邀请好友' }}</div>
          </div>
        </div>
        <div :class="['btn-get', activeInfo.team_reward_get ? 'get' : '']" @click="handleGetInviteReward"></div>
      </div>
      <div class="content5">
        <div :class="['btn-get', activeInfo.is_follow ? (activeInfo.spring_reward_get ? 'got' : ''): 'unfollow']" @click="handleEnterQiwei"></div>
      </div>
      <div class="content6">
        <div class="content-box">
          <div class="avatar"></div>
          <div class="title"></div>
        </div>
      </div>
      <div class="content7">
        <div class="title"></div>
        <div class="play-way-content-box">
          <div class="play-way-swiper-container swiper-no-swiping swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide slide1">
                <div class="info-img-box"></div>
              </div>
              <div class="swiper-slide slide2">
                <div class="info-img-box"></div>
              </div>
              <div class="swiper-slide slide3">
                <div class="info-img-box"></div>
              </div>
            </div>
            <div class="swiper-pagination play-way-pagination">
              <div class="bg"></div>
            </div>
          </div>
          <div class="swiper-button-prev play-way-button-prev"></div>
          <div class="swiper-button-next play-way-button-next"></div>
        </div>
      </div>
    </div>
    <Footer :gameName="gameName" />

    <!-- 预约成功弹窗 -->
    <div class="appoint-success-wrap popup_wrap" v-show="showAppointSuccess" @click="showAppointSuccess = false">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="appoint-success-box" v-show="showAppointSuccess" @click.stop="">
          <img src="../../../../assets/images/active/hjwq/newArea-appoint/bg_appoint_success.png" alt="">
        </div>
      </transition>
    </div>
    <!-- 活动详情 -->
    <div class="detail-wrap popup_wrap" v-show="detailShow" @click="detailShow = false">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="detail-box" v-show="detailShow" @click.stop="">
        </div>
      </transition>
    </div>
    <!-- 邀请弹窗 -->
    <div class="invite-wrap popup_wrap" v-show="inviteShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="invite-box" v-show="inviteShow">
          <div class="link">{{ shareLink }}</div>
          <div class="btn-copy" id="clipboard-share-btn" :data-clipboard-text="'【新仙剑之挥剑问情】仙二「余情」特别服预约开启，与我组队集结共赢土系·星璇，还有更多新春道具好礼等你来拿！ ' + shareLink" @click="onCopyShareLink()"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="inviteShow" @click="closePopup('inviteShow')"></div>
    </div>
    <!-- 区服选择 -->
    <div class="os-wrap popup_wrap" v-show="showOs">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="os-box" v-show="showOs">
          <div class="option-box">
            <div class="input-server">
              <select v-model="roleId">
                <option value="">请选择区组</option>
                <option v-for="(item, index) in allUserInfo" :key="index" :value="item.role_id">
                  {{ item.server_name }}
                </option>
              </select>
            </div>
            <div class="input input-name">
              <input type="text" name="" value="" readonly v-model="roleName" placeholder="请选择角色" />
            </div>
          </div>
          <div class="btn-box">
            <div class="cancell-btn" @click="showOs = false">取消</div>
            <div class="confirm-btn" @click="handleShowConfirm">确认</div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="showOs" @click="closePopup('showOs')"></div>
    </div>
    <!-- 二次确认 -->
    <div class="confirm-wrap popup_wrap" v-show="showConfirm">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="confirm-box" v-show="showConfirm">
          <div class="option-box">
            <div class="input-server">
              【{{ serverName }}】-
            </div>
            <div class="input input-name">
              【{{ roleName }}】
            </div>
          </div>
          <div class="confirm-btn" @click="ok"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="showConfirm" @click="closePopup('showConfirm')"></div>
    </div>
    <!-- 新春礼包二次确认 -->
    <div class="confirm-spring-wrap popup_wrap" v-show="showSpringConfirm">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="confirm-spring-box" v-show="showSpringConfirm">
          <div class="option-box">
            <div class="input-server">
              【{{ info.server_name }}】-
            </div>
            <div class="input input-name">
              【{{ info.role_name }}】
            </div>
          </div>
          <div class="confirm-btn" @click="okSpring"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="showSpringConfirm" @click="closePopup('showSpringConfirm')"></div>
    </div>
    <!-- 领取成功弹窗 -->
    <div class="getReward-success-wrap popup_wrap" v-show="showRewardSuccess" @click="showRewardSuccess = false">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="getReward-success-box" v-show="showRewardSuccess" @click.stop="">
          <div class="btn-confirm" @click="showRewardSuccess = false"></div>
        </div>
      </transition>
    </div>

    <!-- 公众号弹窗 -->
    <div class="wechat-wrap popup_wrap" v-show="showWechat" @click="showWechat = false">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="wechat-box" v-show="showWechat" @click.stop="">
          <img src="../../../../assets/images/active/hjwq/newArea-appoint/bg_wechat.png" alt="">
        </div>
      </transition>
    </div>

    <!-- 加入队伍弹窗 -->
    <div class="join-wrap popup_wrap" v-show="showJoin">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="join-box" v-show="showJoin">
          <div class="content">
            <div>是否接受【大侠-{{friend_name}}】的</div>
            <div>集结邀请加入队伍？</div>
          </div>
          <div class="cancel" @click="handleNotJoinTeam"></div>
          <div class="confirm" @click="handleJoinTeam"></div>
        </div>
      </transition>
    </div>

    <!-- 加入队伍成功弹窗 -->
    <div class="join-success-wrap popup_wrap" v-show="showJoinSuccess" @click="showJoinSuccess = false">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="join-success-box" v-show="showJoinSuccess" @click.stop="">
          <img src="../../../../assets/images/active/hjwq/newArea-appoint/bg_join_success.png" alt="">
        </div>
      </transition>
    </div>

    <!-- 加入队伍失败弹窗 -->
    <div class="join-fail-wrap popup_wrap" v-show="showJoinFail">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="join-fail-box" v-show="showJoinFail" @click.stop="">
          <img src="../../../../assets/images/active/hjwq/newArea-appoint/bg_join_fail2.png" alt="">
          <div class="btn-close" @click="showJoinFail = false"></div>
        </div>
      </transition>
    </div>

    <!-- 不在微信内打开的弹窗 -->
    <div class="other-place-wrap popup_wrap" v-show="showNotInWechat">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="other-place-box" v-show="showNotInWechat">
          <div class="logo"></div>
          <div class="title"></div>
          <div class="code">
            <img src="../../../../assets/images/active/hjwq/newArea-appoint/mobile_code.png" alt="">
          </div>
        </div>
      </transition>
    </div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:loginCallback='selectCallback' :autoOpenOS="false" :gameName="gameName" :loginTypes="['sms', 'password']" downloadUrl="https://hjwq.qingcijoy.com/index.html" channelTips="角色UID可在游戏中—头像—ID查看"></Login>
    <OsChoose v-if='showOsChoose' accountKey="user_account" @closeModal="closeModal" @chooseRole="handleRoleChoose" @cancel="showOsChoose = false" :gameName="gameName" />

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

    <!-- 预加载图片 -->
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_detail.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_wechat.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_join_fail2.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_join_success.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_appoint_success.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/get_success.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_invite.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_join.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/newArea-appoint/bg_os.png" alt="">
  </div>
</template>
<script>
import { Indicator, Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import _ from "lodash";
import { mapState, mapMutations, mapActions } from 'vuex';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import OsChoose from '@/components/OsChoose';
import Swiper from 'swiper'
import "swiper/dist/css/swiper.css"
import { headerConfig } from '../headerConfig';
import { getRandomString, buriedLogger, analysisParams, wechatBrowser } from '@/utils/utils';
import { onGetInitDataAPI, onExchangeProductAPI, onGetNumberAPI, onGetRolesAPI, onEnterTeamAPI } from '../api';

export default {
  name: 'newArea-appoint',
  components: {
    Header,
    Footer,
    Login,
    OsChoose,
  },
  data() {
    return {
      headerConfig,
      gameName: 'hjwq',
      preloadingShow: false,
      titleShow: false,
      shareLink: '', // 助力链接
      preventShow: false,
      logger: null,
      team_info: new Array(4),
      appointNumber: 0,
      showAppointSuccess: false,
      inviteShow: false,
      roleId: '',
      allInfo: {},
      showOs: false,
      detailShow: false,
      showRewardSuccess: false,
      team: [],
      showWechat: false,
      showJoin: false,
      friend_id: '',
      friend_name: '',
      showJoinSuccess: false,
      showJoinFail: false,
      showConfirm: false,
      downLoadShow: false,
      showNotInWechat: false,
      showOsChoose: false,
      showSpringConfirm: false,
      info: {},
      hideMoveDown: false,
    };
  },
  created() {
    // 不是移动端
    if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) window.location.href = `https://h5.qingcigame.com/hjwq/newArea-appoint/pc${getRandomString()}`
    // 如果不在微信内
    if (!wechatBrowser()) {
      return this.showNotInWechat = true
    }
    this.getAppointNumber()
    const { protocol, host } = window.location

    setTimeout(() => {
      this.titleShow = true
      this.initPlayWaySwiper()
      // 清空store上的用户数据
      this.setInitActiveInfo()
      this.setInitUserInfo()
      this.onInit()
    }, 100);

    // 埋点
    const bl = buriedLogger('hjwq', '仙二特别服预约')
    this.logger = bl

    this.setShare({
      title: '余情萦绕 双鲤迎春',
      desc: '《仙剑奇侠传二》「余情」特别服2月2日开启，好友集结可得土系·星璇，赶快点击前往预约！',
      imgUrl: 'https://download4.qcplay.com/qcgame-admin/eCLQTmwuCCbzyTWbQk4UORKn4GdcCGm9bp4NstlP.png',
      link: `${protocol}//${host}/hjwq/newArea-appoint/enter${getRandomString()}`,
    });

  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
    ]),
    allUserInfo() {
      return this.allInfo[69]
        ? this.allInfo[69]['android']
        : []
    },
    roleName() {
      // 当区组为空时, 角色名为空
      let roleName = this.roleId
        ? this.allUserInfo.find(item => item.role_id === this.roleId).role_name
        : ""
      return roleName
    },
    serverName() {
      let serverName = this.roleId
        ? this.allUserInfo.find(item => item.role_id === this.roleId).server_name
        : ""
      return serverName
    }
  },
  watch: {
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleScroll: _.throttle(
      function () {
        const rect = this.$refs.btnNext.getBoundingClientRect() || {}
        if (rect.top < 500 && !this.hideMoveDown) {
          return this.hideMoveDown = true
        }
        if (rect.top >= 500 && this.hideMoveDown) {
          return this.hideMoveDown = false
        }
      },
      100,
      { trailing: false }
    ),
    okSpring() {
      Indicator.open()
      this.preventShow = true
      this.loggerUpload('新春礼包领取')
      onExchangeProductAPI({
        ...this.info,
        type: 2,
      }).then((res) => {
        this.preventShow = false
        Indicator.close()
        this.info = {}
        if (res.code === 200) {
          this.showSpringConfirm = false
          this.showRewardSuccess = true
          onGetInitDataAPI().then(response => {
            this.onInitDataCallback({ ...response, needAccount: false })
          })
        } else {
          this.onToast(res.message)
        }
      }).catch(() => {
        this.preventShow = false;
        Indicator.close();
      });
    },
    closeModal() {
      this.showOsChoose = false
    },
    handleRoleChoose(value) {
      this.info = value
      this.showSpringConfirm = true
      this.showOsChoose = false
    },
    handleShowDetail() {
      this.detailShow = true
      this.loggerUpload('活动规则点击')
    },
    handleShowConfirm() {
      if (this.roleId === "") {
        return this.onToast('请选择区组')
      }
      this.showConfirm = true
      this.showOs = false
    },
    getAppointNumber() {
      onGetNumberAPI().then((res) => {
        this.appointNumber = res.data.number
        this.downLoadShow = res.data.is_open_start
      })
    },
    initPlayWaySwiper() {
      new Swiper('.play-way-swiper-container.swiper-container', {
        direction: 'horizontal',
        slidesPerView: "auto",
        spaceBetween: 0,
        initialSlide: 1,
        loop: true,
        centeredSlides: true,
        pagination: '.play-way-pagination.swiper-pagination',
        nextButton: '.play-way-button-next.swiper-button-next',
        prevButton: '.play-way-button-prev.swiper-button-prev',
        // observer: true,
        // observeParents: true,
        effect: 'coverflow',
        coverflow: {
          // rotate: 30,
          // stretch: 10,
          // depth: 60,
          // modifier: 2,
          rotate: 5,
          stretch: 10,
          depth: 30,
          modifier: 6,
          slideShadows: true
        }
      })
    },
    handleAppoint() {
      this.changeLoginPopup(true)
      this.loggerUpload('立即预约点击')
    },
    handleDownload() {
      this.loggerUpload('立即下载点击')
      setTimeout(() => {
        window.location.href = 'https://hjwq.qingcijoy.com/index_mobile.html'
      }, 500)
    },
    handleInvite() {
      if (!this.userInfo.account) {
        this.changeLoginPopup(true)
        return
      }
      const { protocol, host } = window.location;
      this.shareLink = `${protocol}//${host}/hjwq/newArea-appoint/enter${getRandomString()}?id=${this.userInfo.user_id}&&name=${this.userInfo.account.slice(7)}`
      this.inviteShow = true
      this.loggerUpload('邀请按钮点击')
    },
    onCopyShareLink() {
      const clipboard = new Clipboard('#clipboard-share-btn')
      clipboard.on('success', (e) => {
        this.onToast('已复制链接到剪贴板 快去集结仙友吧！ ')
        e.clearSelection()
      })

      clipboard.on('error', (e) => {
        this.onToast('复制失败')
      });
      this.inviteShow = false
      this.loggerUpload('复制组队邀请链接')
    },
    handleGetInviteReward() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      if (this.activeInfo.team_reward_get) {
        this.onToast('您已领取过奖励了!')
        return
      }
      const number = this.team.filter((i) => i.nickname).length
      if (number < 4) {
        return this.onToast('队伍还未集结满员哦!')
      }
      if (!this.activeInfo.is_reward_start) {
        return this.onToast('奖励领取还未开放!')
      }
      Indicator.open()
      onGetRolesAPI().then((res) => {
        Indicator.close()
        if (Number(res.code) === 200) {
          if (!res.data[69] || !res.data[69].android || !res.data[69].android.length) {
            return this.onToast('您的新服还没有角色哦，快去创建吧')
          }
          let data = res.data
          // 存该用户所有的账号信息
          this.allInfo = data
          this.showOs = true
        } else {
          this.onToast(res.message)
        }
      }).catch(() => {
        Indicator.close()
      })
    },
    handleEnterQiwei() {
      if (!this.activeInfo.is_follow) {
        return this.showWechat = true
      }
      if (this.activeInfo.spring_reward_get) {
        return this.onToast('您已领取过了')
      }
      if (!this.activeInfo.is_reward_start) {
        return this.onToast('奖励领取还未开放!')
      }
      this.showOsChoose = true
    },
    handleNotJoinTeam() {
      this.showJoin = false
      this.loggerUpload('接受邀请弹窗：【取消】')
    },
    handleJoinTeam() {
      this.loggerUpload('接受邀请弹窗：【接受】')
      onEnterTeamAPI({ friend_id: this.friend_id }).then((res) => {
        if (res.code === 200) {
          this.showJoinSuccess = true
          this.showJoin = false
          this.friend_id = ''
          this.friend_name = ''
          onGetInitDataAPI().then(response => {
            this.onInitDataCallback({ ...response, needAccount: false })
            if (response.code === 200) {
              this.team = response.data.activity.team_info || []
            }
          })
        } else if (res.code === 408) {
          this.showJoinFail = true
        } else {
          this.onToast(res.message)
        }
      })
    },
    ok: _.throttle(
      function () {
        if (this.roleId === "") {
          return this.onToast('请选择区组')
        }
        if (!this.roleName || !this.roleId) {
          return
        }
        let selectInfo = this.allUserInfo.find(
          item => item.role_id === this.roleId
        )
        Indicator.open()
        this.loggerUpload('组队奖励领取按钮点击')
        onExchangeProductAPI({
          type: 1,
          ...selectInfo,
        }).then((res) => {
          this.preventShow = false
          Indicator.close()
          if (res.code === 200) {
            this.showOs = false
            this.showRewardSuccess = true
            onGetInitDataAPI().then(response => {
              this.onInitDataCallback({ ...response, needAccount: false })
            })
          } else {
            this.onToast(res.message)
          }
        }).catch(() => {
          this.preventShow = false;
          Indicator.close();
        });
      },
      1000,
      { trailing: false }
    ),
    // 选择角色后
    selectCallback() {
      this.onInit((response) => {
        const is_new = response.data.activity.is_new
        if (!is_new) {
          return
        }
        const params = analysisParams(window.location.href)
        if (params.id) {
          // this.onToast('预约成功')
        } else {
          this.showAppointSuccess = true
        }
      });
    },
    // 注销-相关参数复位
    reInit() {
      this.clearData();
    },
    // 清楚数据
    clearData() {
      this.roleId = ''
      this.allInfo = {}
      this.team = []
      this.friend_id = ''
      this.friend_name = ''
    },
    // 初始化用户信息
    onInit(cb) {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback({ ...response, needAccount: false })
        if (response.code === 200) {
          cb && cb(response)
          this.team = response.data.activity.team_info || []
          const params = analysisParams(window.location.href)
          this.friend_id = params.id
          this.friend_name = params.name
          if (params.id) {
            this.showJoin = true
            // if (!response.data.activity.is_has_team) {
            //   this.showJoin = true
            // } else {
            //   this.onToast('加入失败，您已存在两人以上队伍，无法加入他人队伍')
            // }
          }
        }
      })
    },
    closePopup(name) {
      this[name] = false
    },
    loggerUpload(point) {
      this.logger.sum(`仙二预约企${point}`)
    },
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setActiveInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  },
};
</script>

<style lang='less' scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/newArea-appoint/index/index.vue